import {init, captureException, captureMessage, browserTracingIntegration, replayIntegration, feedbackIntegration, setUser } from '@sentry/vue'

const {VITE_SENTRY_ENABLED, VITE_ENV, VITE_SENTRY_DSN, VITE_SENTRY_SAMPLE_RATE} = import.meta.env

export const SENTRY_ENABLED = VITE_SENTRY_ENABLED?.toLowerCase() == 'true'

export const sentryInit = (app, router) => {
  if (SENTRY_ENABLED) {
    init({
      app,
      environment: VITE_ENV,
      dsn: VITE_SENTRY_DSN,
      tunnel: '/api/sentry',
      ignoreErrors: [
        'Failed to fetch dynamically imported module', 'FST_JWT_AUTHORIZATION_TOKEN_EXPIRED',
        'Email not found', 'Invalid Password', 'Your One-Time Passcode is invalid'
      ],
      integrations: [
        browserTracingIntegration({ router }),
        ...(VITE_ENV == 'production'
          ? [replayIntegration({ networkDetailAllowUrls: [window.location.origin] })]
          : []),
        // feedbackIntegration({
        //   showName: false,
        //   showEmail: false,
        //   colorScheme: 'system',
        // })
      ],
      tracesSampleRate: VITE_SENTRY_SAMPLE_RATE || 0.1,
      tracePropagationTargets: [
        /^https:\/\/uad\.ustechsupport\.com/,
        /^https:\/\/uad-stage\.ustechsupport\.com/,
        /^https:\/\/uad-demo\.ustechsupport\.com/,
        /^https:\/\/uad\.techinnovators\.dev/,
        /^http:\/\/localhost:\d+/,
        /^\/api\//,
      ],
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: VITE_ENV == 'production' ? 1.0 : 0
    })
  }
}

export const sentryException = data => SENTRY_ENABLED ? captureException(data) : null
export const sentryMessage = data => SENTRY_ENABLED ? captureMessage(data) : null
export const sentryUser = data => SENTRY_ENABLED ? setUser(data) : null